import { gql } from "@apollo/client";

// eslint-disable-next-line import/prefer-default-export
export const SEND_PPA_REMINDER_EMAILS = gql`
  mutation SendPPAReminderEmails($evaluationIds: [String!]!) {
    sendPPAReminderEmails(evaluationIds: $evaluationIds)
  }
`;
